export const HHDSButtonHasRegisterPropertyClass = "has-register-property";

export default class HHDSButtonUtils {
  static addCustomProperty() {
    const property = "--conic-gradient-rotation";

    if (
      HHDSButtonUtils.isPropertyRegistered(document.body, property) === false
    ) {
      const { registerProperty } = window.CSS as any;

      if (!registerProperty) return;

      registerProperty({
        name: property,
        syntax: "<angle>",
        inherits: false,
        initialValue: "0.75turn",
      });
    }
  }

  // ////////////////////////////////////////////////////////////////////

  static isPropertyRegistered(target: HTMLElement, propertyName: string) {
    // Check if the property is recognized by getComputedStyle
    const computedStyle = getComputedStyle(target);
    const isRegistered = computedStyle.getPropertyValue(propertyName) !== "";

    return isRegistered;
  }
}
